<template>
  <div class="footer">
    <el-row type="flex" justify="center" align="middle" style="height: 60px;font-size: 14px;font-weight: 500;line-height: 17px;
    color: #fff">
        <span style="font-size: 14px;line-height: 17px;
color: #000;">{{$store.getters.systemConfig.notaryName}}</span>
      <span style="color: #000">咨询电话：<span
        style="color: rgba(44, 105, 236, 1);">{{$store.getters.systemConfig.notaryPhone}}</span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span style="font-size: 14px;color: #000;">{{$store.getters.systemConfig.icp}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <span style="font-size: 14px;line-height: 17px;
color: #000;">
        友情链接：<a href="https://www.ebaoquan.org/" style="
color:rgba(44, 105, 236, 1);font-size: 14px;">易保全</a>
         <a href="https://www.junziqian.com/" style="
color: rgba(44, 105, 236, 1);font-size: 14px;margin: 0 20px">君子签</a>
         <a href="https://www.wbq360.com/" style="
color: rgba(44, 105, 236, 1);font-size: 14px">微版权</a>
      </span>&nbsp;&nbsp;&nbsp;
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "LoginFooter"
    }
</script>

<style scoped>
  .footer {
    position: absolute;
    bottom: 0;
    width: 100%;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginFooter.vue